import { Controller } from "stimulus";
export default class extends Controller {
  //
  // life cycle
  //
  initialize() {
  }

  //
  // target
  //
  static targets = [
    'hidden',
  ]

  //
  // article
  //
  showAll() {
    this.hiddenTargets.forEach((hiddenTarget) => {
      $(hiddenTarget).addClass('hidden');
    });
    $('div[data-target="service--night.show"]').removeClass('hidden');
  }
};

